import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import AgentBotManagementAPI from '../../api/agentBotManagement';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getAgentBotManagement(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  getAgentBotManagement: async function getAgentBotManagement(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { fetchingList: true });
    try {
      const response = await AgentBotManagementAPI.get({ searchKey });
      commit(types.default.SET_AGENT_BOT_MANAGEMENT, response.data);
    } finally {
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { fetchingList: false });
    }
  },
  
  createAgentBotManagement: async function createAgentBotManagement(
    { commit },
    agentBotObj
  ) {
    commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { creatingItem: true });
    try {
      const response = await AgentBotManagementAPI.create(agentBotObj);
      commit(types.default.ADD_AGENT_BOT_MANAGEMENT, response.data);
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { creatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { creatingItem: false });
      return throwErrorMessage(error);
    }
  },
  
  updateAgentBotManagement: async function({ commit }, { id, formData }) {
    commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { updatingItem: true });
    try {
      const response = await AgentBotManagementAPI.update(id, formData);
      commit(types.default.EDIT_AGENT_BOT_MANAGEMENT, response.data);
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { updatingItem: false });
      return response.data;
    } catch (error) {
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { updatingItem: false });
      return throwErrorMessage(error);
    }
  },
  
  deleteAgentBotManagement: async function deleteAgentBotManagement({ commit }, id) {
    commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { deletingItem: true });
    try {
      await AgentBotManagementAPI.delete(id);
      commit(types.default.DELETE_AGENT_BOT_MANAGEMENT, id);
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { deletingItem: false });
      return id;
    } catch (error) {
      commit(types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG, { deletingItem: false });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_AGENT_BOT_MANAGEMENT_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  
  [types.default.SET_AGENT_BOT_MANAGEMENT]: MutationHelpers.set,
  [types.default.ADD_AGENT_BOT_MANAGEMENT]: MutationHelpers.create,
  [types.default.EDIT_AGENT_BOT_MANAGEMENT]: MutationHelpers.update,
  [types.default.DELETE_AGENT_BOT_MANAGEMENT]: MutationHelpers.destroy,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
